import logo1 from '../../../assets/images/Frame 35.png'
import logo2 from '../../../assets/images/Frame 47.png'
import logo3 from '../../../assets/images/Frame 35.png'
import logo4 from '../../../assets/images/logo7.png'
import logo5 from '../../../assets/images/logo4.png'

export default function LogoCards() {
    const AllImg = [logo1, logo2, logo3, logo4, logo5]

    return (
        <section className="container my-4">
            <div className="row justify-content-center">
                {AllImg.map((item, idx) => (
                    <div
                        key={idx}
                        className="col-12 col-sm-6 col-md-4 mb-4 d-flex justify-content-center"
                    >
                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{
                                backgroundColor: '#fff',
                                padding: '0px',
                                borderRadius: '12px',
                                cursor: 'pointer',
                                width:"320px",
                                height: '100%',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                            }}
                        >
                            <img
                                src={item}
                                alt={`logo-${idx}`}
                                className="img-fluid"
                                style={{ maxHeight: '70px', padding: '5px' }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </section>
    )
}
